import React from 'react'
import PropTypes from 'prop-types'

// ---------------------
ContactForm.propTypes = {

}

export default function ContactForm () {
  // form handlers can go here.
  return (
    <section className="contact Form relative bg-secondary text-white py-12 mb-0">
      <div className="container">
        <h2>Contact Us</h2>

        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Doloremque velit, deleniti, quibusdam aliquid esse dolorum reiciendis inventore et debitis ab </p>

        <form>
          <div className='grid grid-cols-1 md:grid-cols-2 gap-4 py-8 text-lg'>
            <div>
              <div className="formGroup mb-4">
                <label htmlFor="firstname" className='block'>First Name</label>
                <input type="text" name="firstname" className='w-full'></input>
              </div>
              <div className="formGroup mb-4">
                <label htmlFor="lastname" className='block'>Last Name</label>
                <input type="text" name="lastname" className='w-full'></input>
              </div>
            </div>
            <div>

            <div className="formGroup mb-4">
                <label htmlFor="email" className='block'>Email</label>
                <input type="text" name="email" className='w-full'></input>
              </div>
              <div className="formGroup mb-4">
                <label htmlFor="company" className='block'>Company</label>
                <input type="text" name="company" className='w-full'></input>
              </div>
            </div>
          </div>

          <input type="submit" className="btn m-auto block" value="Submit"/>

        </form>

      </div>

    </section>
  )
}
